import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getVideos = createAsyncThunk(
  "videos/getVideos",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", filter = {} } = args;

      // Clean filter object - only include non-empty values
      const cleanFilter = {};
      Object.keys(filter).forEach(key => {
        const value = filter[key];
        if (value !== null && value !== undefined && value !== "") {
          cleanFilter[key] = value;
        }
      });

      const filterStr = filterRequest(cleanFilter);

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("size", size);
      if (query) params.append("search", query);

      const { data } = await axiosInstance.get(
        `/reels?${params.toString()}${filterStr}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createVideo = createAsyncThunk(
  "videos/createVideo",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/reels`, args);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateVideo = createAsyncThunk(
  "videos/updateVideo",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/reels/${args._id}/status`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteVideo = createAsyncThunk(
  "videos/deleteVideo",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(`/reels/${args._id}`);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const videosSlice = createSlice({
  name: "videos",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getVideos.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getVideos.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data?.data;
        state.itemsCount = payload.data?.itemsCount;
        state.pages = payload.data?.pages;
        state.error = null;
      })
      .addCase(getVideos.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createVideo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createVideo.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createVideo.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateVideo.pending, (state) => {
        state.isLoading = true;
        // state.error = null;
      })
      .addCase(updateVideo.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // const indexAt = state.data.findIndex(
        //   (el) => el._id === payload.data._id
        // );
        // if (indexAt !== -1) {
        //   state.data[indexAt] = payload.data;
        // }
        // state.error = null;
      })
      .addCase(updateVideo.rejected, (state, { payload }) => {
        state.isLoading = false;
        // state.error = payload?.message;
      })

      .addCase(deleteVideo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteVideo.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // state.data = state.data.filter((el) => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteVideo.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      });
  },
});

export default videosSlice.reducer;
